import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import classes from './LogSubNav.module.css';
import { LogsFilter } from 'components/Filters';
import CategoryIcon from 'components/UI/NavIcons/CategoryIcon/CategoryIcon';
import GalleryIcon from 'components/UI/NavIcons/GalleryIcon/GalleryIcon';
import LargePostsView from 'components/UI/NavIcons/LargePostsView/LargePostsView';
import PeopleIcon from 'components/UI/NavIcons/PeopleIcon/PeopleIcon';
import SmallPostsView from 'components/UI/NavIcons/SmallPostsView/SmallPostsView';
import { GiftIcon } from 'components/UI/SVGIcons/SVGIcons';
import LogViewFilters from 'containers/Log/LogViewFilters/LogViewFilters';

class LogSubNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubNav: true,
      lastScrollPosition: 0,
      showLogsComponent: false,
      showSortComponent: false,
      showViewTypeComponent: false,
      showFilterComponent: false,
    };
    this.container = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('mousedown', this.handleClickOutside);
    // setup scroll listener to hide subnav when user scrolls down and show when user scrolls up
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    if (this.props.showPostDetailNavOptions) {
      this.props.onTogglePostDetailNavOptions();
    }
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  }

  // This function updates state to indicate that the subnav should be closed on scroll down and revealed on scroll up
  handleScroll = () => {
    const currentScrollPos = window.pageYOffset;

    if (
      currentScrollPos > 100 &&
      currentScrollPos > this.state.lastScrollPosition &&
      !this.state.showFilterComponent &&
      !this.state.showLogsComponent
    ) {
      this.setState({ showSubNav: false });
    } else {
      this.setState({ showSubNav: true });
    }
    this.setState({ lastScrollPosition: currentScrollPos });
  };

  closeAllWindows = () => {
    this.setState({ showLogsComponent: false, showSortComponent: false, showViewTypeComponent: false, showFilterComponent: false });
  };

  toggleComponent = (componentName) => {
    this.closeAllWindows();
    this.setState({ [componentName]: !this.state[componentName] });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 27) {
      this.closeAllWindows();
    }
  };

  handleLinkClick = (linkName) => {
    this.closeAllWindows();
    this.props.handleLinkClick(linkName);
  };

  handleViewUpdate = (viewType) => {
    this.toggleComponent('showViewTypeComponent');
    this.props.handleViewUpdate(viewType);
  };

  handleClickOutside = (e) => {
    // if we click is either outside of the subnav
    // or empty space within the subnav
    // when a subnav window is open, close window
    if (
      (this.container.current && e.target && !this.container.current.contains(e.target)) ||
      e.target.id === 'subnav-right-container' ||
      e.target.id === 'subnav-container'
    ) {
      if (
        this.state.showLogsComponent === true ||
        this.state.showSortComponent === true ||
        this.state.showViewTypeComponent === true ||
        this.state.showFilterComponent === true
      ) {
        this.closeAllWindows();
      }
    }
  };

  render = () => {
    const containerClasses = [classes.SubNavOuterContainer];

    const logsContainerClasses = [classes.LogsContainer];
    const sortContainerClasses = [classes.SortContainer];
    const viewTypeContainerClasses = [classes.ViewTypeContainer];
    const filterContainerClasses = [classes.FilterContainer];

    const timelineViewSelectionClasses = [classes.ViewOptionContainer];
    const listViewSelectionClasses = [classes.ViewOptionContainer];
    const galleryViewSelectionClasses = [classes.ViewOptionContainer];
    const categoryViewSelectionClasses = [classes.ViewOptionContainer];
    const peopleViewSelectionClasses = [classes.ViewOptionContainer];

    const largePostsViewIconClasses = [classes.PostSizeIconContainer, classes.Large];
    const smallPostsViewIconClasses = [classes.PostSizeIconContainer, classes.Small];

    if (this.props.postViewSize === 'small') {
      smallPostsViewIconClasses.push(classes.Active);
    } else {
      largePostsViewIconClasses.push(classes.Active);
    }

    const sortTitle =
      this.props.selectedSortColumn === 'DateStart'
        ? this.props.sortColumns.DateStart.sortOrder === 'desc'
          ? 'Newest Post 1st'
          : 'Oldest Post 1st'
        : this.props.selectedSortColumn === 'DatePostUpdated'
        ? 'Date Modified'
        : this.props.selectedSortColumn === 'DateCreated'
        ? 'Date Added'
        : '';
    const postSizeToggleViewable = ['timeline', 'category', 'people', 'gallery'].includes(this.props.currentView);

    const viewTypeIconMouseOver = () => {
      // let containerClasses = type === 'gallery' ? galleryViewSelectionClasses : categoryViewSelectionClasses;
      // if (true) {
      //   containerClasses.push(classes.Active);
      // } else if (this.props.currentView === type) {
      //   containerClasses = [classes.Active, classes.ViewOptionContainer];
      // } else {
      //   containerClasses = [classes.ViewOptionContainer];
      // }
    };

    let filteringSet = false;
    Object.keys(this.props.filters).forEach((filterKey, i) => {
      if (
        (filterKey !== 'logIds' && Object.values(this.props.filters)[i] !== null && Object.values(this.props.filters)[i].length > 0) ||
        Object.values(this.props.filters)[i] === true
      )
        filteringSet = true;
    });
    Object.keys(this.props.filters.tags).forEach((tagType) => {
      if (this.props.filters.tags[tagType].length > 0) filteringSet = true;
    });
    let logsSelectorTitle = 'Select Log(s)';
    if (this.props.logs && this.props.filters.logIds.length > 0) {
      if (this.props.filters.logIds.length === 1) {
        logsSelectorTitle = this.props.logs.find((log) => log.Id === this.props.filters.logIds[0])
          ? this.props.logs.find((log) => log.Id === this.props.filters.logIds[0]).Name
          : logsSelectorTitle;
      } else if (this.props.filters.logIds.length === this.props.logs.length) {
        logsSelectorTitle = 'All Logs';
      } else if (this.props.currentPath.includes('/life-shared/drafts')) {
        logsSelectorTitle = 'Drafts';
      } else {
        logsSelectorTitle = 'Multiple Logs';
      }
    }

    if (this.state.showSubNav) containerClasses.push(classes.Shown);

    if (this.state.showLogsComponent) logsContainerClasses.push(classes.Open);
    if (this.props.postingAs.GiftsDraftsCount && this.props.postingAs.GiftsDraftsCount > 0) logsContainerClasses.push(classes.ShowGiftIcon);
    if (this.state.showSortComponent) sortContainerClasses.push(classes.Open);
    if (this.state.showViewTypeComponent) viewTypeContainerClasses.push(classes.Open);
    if (this.state.showFilterComponent) filterContainerClasses.push(classes.Open);

    if (this.props.currentView === 'timeline') {
      timelineViewSelectionClasses.push(classes.Selected);
    } else if (this.props.currentView === 'list') {
      listViewSelectionClasses.push(classes.Selected);
    } else if (this.props.currentView === 'gallery') {
      galleryViewSelectionClasses.push(classes.Selected);
    } else if (this.props.currentView === 'people') {
      peopleViewSelectionClasses.push(classes.Selected);
    } else if (this.props.currentView === 'category') {
      categoryViewSelectionClasses.push(classes.Selected);
    }

    return (
      <div ref={this.container} className={containerClasses.join(' ')}>
        <div className={this.state.showFilterComponent ? [classes.BlackoutBackground, classes.Shown].join(' ') : classes.BlackoutBackground} />
        <div className={classes.InnerContainerWrapper}>
          <div id="subnav-container" className={classes.SubNavInnerContainer}>
            <div className={logsContainerClasses.join(' ')}>
              <div className={classes.Label}>
                <div onClick={() => this.toggleComponent('showLogsComponent')}>
                  <span>{logsSelectorTitle}</span>
                  <FontAwesomeIcon icon="chevron-down" className={classes.ChevronDownIcon} />
                </div>
                {this.props.postingAs.GiftsDraftsCount && this.props.postingAs.GiftsDraftsCount > 0 ? (
                  <GiftIcon className={classes.GiftIcon} type="Subnav" clicked={this.props.toggleGiftsDrafts} />
                ) : null}
              </div>

              <div className={classes.WindowComponent}>
                <LogsFilter
                  isManagedUser={this.props.isManagedUser}
                  allLogs={this.props.logs}
                  selectedLogIds={this.props.filters.logIds}
                  selectAll={this.props.handleSelectAllLogs}
                  handleLogSelect={this.props.handleLogSelect}
                  clearAll={this.props.handleLogsClear}
                />
              </div>
            </div>
            <div id="subnav-right-container" className={classes.RightHandComponentsContainer}>
              {postSizeToggleViewable ? (
                <div className={sortContainerClasses.join(' ')}>
                  <div className={classes.Label} onClick={() => this.toggleComponent('showSortComponent')}>
                    <span>Sort by {sortTitle}</span>
                    <FontAwesomeIcon icon="chevron-down" className={classes.ChevronDownIcon} />
                  </div>
                  <div className={classes.WindowComponent}>
                    <div className={classes.SortBy}>
                      <div className={classes.SortOption} onClick={() => this.props.handleSortChange('DateStart', 'desc')}>
                        <span>Newest Post 1st</span>
                        {this.props.selectedSortColumn === 'DateStart' && this.props.sortColumns.DateStart.sortOrder === 'desc' ? (
                          <FontAwesomeIcon icon="check" className={classes.CheckMark} />
                        ) : null}
                      </div>
                      <div className={classes.SortOption} onClick={() => this.props.handleSortChange('DateStart', 'asc')}>
                        <span>Oldest Post 1st</span>
                        {this.props.selectedSortColumn === 'DateStart' && this.props.sortColumns.DateStart.sortOrder === 'asc' ? (
                          <FontAwesomeIcon icon="check" className={classes.CheckMark} />
                        ) : null}
                      </div>
                      <div className={classes.SortOption} onClick={() => this.props.handleSortChange('DatePostUpdated', 'desc')}>
                        <span>Date Modified</span>
                        {this.props.selectedSortColumn === 'DatePostUpdated' ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
                      </div>
                      <div className={classes.SortOption} onClick={() => this.props.handleSortChange('DateCreated', 'desc')}>
                        <span>Date Added</span>
                        {this.props.selectedSortColumn === 'DateCreated' ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {postSizeToggleViewable ? (
                <div className={classes.PostViewSizeContainer}>
                  <div onClick={this.props.togglePostViewSize} className={smallPostsViewIconClasses.join(' ')}>
                    <SmallPostsView />
                  </div>
                  <div onClick={this.props.togglePostViewSize} className={largePostsViewIconClasses.join(' ')}>
                    <LargePostsView />
                  </div>
                </div>
              ) : null}
              <div className={viewTypeContainerClasses.join(' ')}>
                <div
                  className={
                    this.props.currentView === 'gallery'
                      ? [classes.Label, classes.GallerySelected].join(' ')
                      : this.props.currentView === 'category'
                      ? [classes.Label, classes.CategorySelected].join(' ')
                      : classes.Label
                  }
                  onClick={() => this.toggleComponent('showViewTypeComponent')}
                >
                  {this.props.currentView === 'gallery' ? (
                    <GalleryIcon type="SubNav" fillColor="#01a2db" alt="gallery" />
                  ) : this.props.currentView === 'people' ? (
                    <PeopleIcon type="SubNavLabel" fillColor="#01a2db" alt="people" />
                  ) : this.props.currentView === 'category' ? (
                    <CategoryIcon type="SubNav" fillColor="#01a2db" alt="category" />
                  ) : (
                    <FontAwesomeIcon
                      icon={this.props.currentView === 'timeline' ? ['far', 'hourglass'] : 'list'}
                      className={classes.ViewOptionIcon}
                    />
                  )}
                </div>

                <div className={classes.WindowComponent}>
                  <div className={timelineViewSelectionClasses.join(' ')} onClick={() => this.handleViewUpdate('timeline')}>
                    <div className={classes.IconContainer}>
                      <FontAwesomeIcon icon={['far', 'hourglass']} className={classes.ViewOptionIcon} />
                    </div>
                    <span>Timeline</span>
                  </div>
                  <div className={listViewSelectionClasses.join(' ')} onClick={() => this.handleViewUpdate('list')}>
                    <div className={classes.IconContainer}>
                      <FontAwesomeIcon icon="list" className={classes.ViewOptionIcon} />
                    </div>
                    <span>List</span>
                  </div>
                  <div
                    className={galleryViewSelectionClasses.join(' ')}
                    onClick={() => this.handleViewUpdate('gallery')}
                    onMouseEnter={() => viewTypeIconMouseOver('gallery', true)}
                    onMouseLeave={() => viewTypeIconMouseOver('gallery', false)}
                  >
                    <div className={classes.IconContainer}>
                      <GalleryIcon className="ViewOptionIcon" alt="gallery" />
                    </div>
                    <span>Gallery</span>
                  </div>
                  <div
                    className={categoryViewSelectionClasses.join(' ')}
                    onClick={() => this.handleViewUpdate('category')}
                    onMouseEnter={() => viewTypeIconMouseOver('category', true)}
                    onMouseLeave={() => viewTypeIconMouseOver('category', false)}
                  >
                    <div className={[classes.IconContainer, classes.Category].join(' ')}>
                      <CategoryIcon className="ViewOptionIcon" alt="category" />
                    </div>
                    <span>Category</span>
                  </div>
                  <div
                    className={peopleViewSelectionClasses.join(' ')}
                    onClick={() => this.handleViewUpdate('people')}
                    onMouseEnter={() => viewTypeIconMouseOver('people', true)}
                    onMouseLeave={() => viewTypeIconMouseOver('people', false)}
                  >
                    <div className={[classes.IconContainer, classes.People].join(' ')}>
                      <PeopleIcon className="ViewOptionIcon" alt="people" />
                    </div>
                    <span>People</span>
                  </div>
                </div>
              </div>
              <div className={filterContainerClasses.join(' ')}>
                <div
                  onClick={() => this.toggleComponent('showFilterComponent')}
                  className={this.state.showFilterComponent || filteringSet ? [classes.Label, classes.Active].join(' ') : classes.Label}
                >
                  <span>Filters {filteringSet ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}</span>
                </div>
                <div className={classes.WindowComponent}>
                  <LogViewFilters
                    close={() => this.setState({ showFilterComponent: false })}
                    show={this.state.showFilterComponent}
                    currentLogs={this.props.currentLogs}
                    filters={this.props.filters}
                    importantPlaces={this.props.importantPlaces}
                    tags={this.props.tags}
                    postingAs={this.props.postingAs}
                    handleFilterUpdate={this.props.handleFilterUpdate}
                    handleClearAllFilters={this.props.handleClearAllFilters}
                    filteringSet={filteringSet}
                  />
                </div>
              </div>
              <div className={classes.PostActions}>
                <FontAwesomeIcon id="add-post" onClick={this.props.handleAddPostLaunch} className={classes.AddPostIcon} icon="plus" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default LogSubNav;
